/* eslint-disable */
// @ts-nocheck

import {
  Value, 
	Struct, 
	ListValue
} from "@bufbuild/protobuf";
import * as reboot_api from "@reboot-dev/reboot-api";
import * as reboot_web from "@reboot-dev/reboot-web";
import { v4 as uuidv4 } from "uuid";
// NOTE NOTE NOTE
//
// If you are reading this comment because you are trying to debug
// the error:
//
// Module not found: Error: Can't resolve './authority_pb.js'
//
// You can resolve this by passing --web-extensions to `rbt
// generate` (or better put it in your `.rbtrc` file).
//
// This is a known issue if you're using `webpack` which uses
// `ts-loader` (https://github.com/TypeStrong/ts-loader/issues/465).
import {
  PageAuthority as PageAuthorityProto,
} from "./authority_pb";
import * as authority_pb from "./authority_pb";
// Additionally re-export all messages_and_enums from the pb module.
export {
  Commit,
  InitializeRequest,
  InitializeResponse,
  PageRequest,
  PageResponse,
  ApplyRequest,
  ApplyResponse,
  ChangesRequest,
  ChangesResponse,
} from "./authority_pb";

import * as protobuf_es from "@bufbuild/protobuf";



const ERROR_TYPES = [
  // gRPC errors.
  reboot_api.errors_pb.Cancelled,
  reboot_api.errors_pb.Unknown,
  reboot_api.errors_pb.InvalidArgument,
  reboot_api.errors_pb.DeadlineExceeded,
  reboot_api.errors_pb.NotFound,
  reboot_api.errors_pb.AlreadyExists,
  reboot_api.errors_pb.PermissionDenied,
  reboot_api.errors_pb.ResourceExhausted,
  reboot_api.errors_pb.FailedPrecondition,
  reboot_api.errors_pb.Aborted,
  reboot_api.errors_pb.OutOfRange,
  reboot_api.errors_pb.Unimplemented,
  reboot_api.errors_pb.Internal,
  reboot_api.errors_pb.Unavailable,
  reboot_api.errors_pb.DataLoss,
  reboot_api.errors_pb.Unauthenticated,
  // Reboot errors.
  //
  // NOTE: also add any new errors into `rbt/v1alpha1/index.ts`.
  reboot_api.errors_pb.StateAlreadyConstructed,
  reboot_api.errors_pb.StateNotConstructed,
  reboot_api.errors_pb.TransactionParticipantFailedToPrepare,
  reboot_api.errors_pb.TransactionParticipantFailedToCommit,
  reboot_api.errors_pb.UnknownService,
  reboot_api.errors_pb.UnknownTask,
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const PageAuthorityInitializeRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<authority_pb.InitializeRequest>
): PageAuthority.InitializeRequest => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof authority_pb.InitializeRequest
    ? partialRequest
    : authority_pb.InitializeRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const PageAuthorityInitializeRequestFromJsonString = (
  jsonRequest: string
): PageAuthority.InitializeRequest => {
  return PageAuthorityInitializeRequestFromProtobufShape(
    authority_pb.InitializeRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const PageAuthorityInitializeRequestToProtobuf = (
  partialRequest?: PageAuthority.PartialInitializeRequest
): authority_pb.InitializeRequest => {
  return partialRequest instanceof authority_pb.InitializeRequest
    ? partialRequest
    : new authority_pb.InitializeRequest(
      partialRequest
    );
};

const PageAuthorityInitializeResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<authority_pb.InitializeResponse>
) => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof authority_pb.InitializeResponse
    ? partialResponse
    : authority_pb.InitializeResponse.fromJson(partialResponse);

  return response;
};

const PageAuthorityInitializeResponseToProtobuf = (
  partialResponse?: PageAuthority.PartialInitializeResponse
): authority_pb.InitializeResponse => {
  return partialResponse instanceof authority_pb.InitializeResponse
    ? partialResponse
    : new authority_pb.InitializeResponse(
      partialResponse
    );
};


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const PageAuthorityPageRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<authority_pb.PageRequest>
): PageAuthority.PageRequest => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof authority_pb.PageRequest
    ? partialRequest
    : authority_pb.PageRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const PageAuthorityPageRequestFromJsonString = (
  jsonRequest: string
): PageAuthority.PageRequest => {
  return PageAuthorityPageRequestFromProtobufShape(
    authority_pb.PageRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const PageAuthorityPageRequestToProtobuf = (
  partialRequest?: PageAuthority.PartialPageRequest
): authority_pb.PageRequest => {
  return partialRequest instanceof authority_pb.PageRequest
    ? partialRequest
    : new authority_pb.PageRequest(
      partialRequest
    );
};

const PageAuthorityPageResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<authority_pb.PageResponse>
) => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof authority_pb.PageResponse
    ? partialResponse
    : authority_pb.PageResponse.fromJson(partialResponse);

  return response;
};

const PageAuthorityPageResponseToProtobuf = (
  partialResponse?: PageAuthority.PartialPageResponse
): authority_pb.PageResponse => {
  return partialResponse instanceof authority_pb.PageResponse
    ? partialResponse
    : new authority_pb.PageResponse(
      partialResponse
    );
};


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const PageAuthorityApplyRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<authority_pb.ApplyRequest>
): PageAuthority.ApplyRequest => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof authority_pb.ApplyRequest
    ? partialRequest
    : authority_pb.ApplyRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const PageAuthorityApplyRequestFromJsonString = (
  jsonRequest: string
): PageAuthority.ApplyRequest => {
  return PageAuthorityApplyRequestFromProtobufShape(
    authority_pb.ApplyRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const PageAuthorityApplyRequestToProtobuf = (
  partialRequest?: PageAuthority.PartialApplyRequest
): authority_pb.ApplyRequest => {
  return partialRequest instanceof authority_pb.ApplyRequest
    ? partialRequest
    : new authority_pb.ApplyRequest(
      partialRequest
    );
};

const PageAuthorityApplyResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<authority_pb.ApplyResponse>
) => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof authority_pb.ApplyResponse
    ? partialResponse
    : authority_pb.ApplyResponse.fromJson(partialResponse);

  return response;
};

const PageAuthorityApplyResponseToProtobuf = (
  partialResponse?: PageAuthority.PartialApplyResponse
): authority_pb.ApplyResponse => {
  return partialResponse instanceof authority_pb.ApplyResponse
    ? partialResponse
    : new authority_pb.ApplyResponse(
      partialResponse
    );
};


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const PageAuthorityChangesRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<authority_pb.ChangesRequest>
): PageAuthority.ChangesRequest => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof authority_pb.ChangesRequest
    ? partialRequest
    : authority_pb.ChangesRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const PageAuthorityChangesRequestFromJsonString = (
  jsonRequest: string
): PageAuthority.ChangesRequest => {
  return PageAuthorityChangesRequestFromProtobufShape(
    authority_pb.ChangesRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const PageAuthorityChangesRequestToProtobuf = (
  partialRequest?: PageAuthority.PartialChangesRequest
): authority_pb.ChangesRequest => {
  return partialRequest instanceof authority_pb.ChangesRequest
    ? partialRequest
    : new authority_pb.ChangesRequest(
      partialRequest
    );
};

const PageAuthorityChangesResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<authority_pb.ChangesResponse>
) => {
  // TOOD: update `convertFromProtobuf()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof authority_pb.ChangesResponse
    ? partialResponse
    : authority_pb.ChangesResponse.fromJson(partialResponse);

  return response;
};

const PageAuthorityChangesResponseToProtobuf = (
  partialResponse?: PageAuthority.PartialChangesResponse
): authority_pb.ChangesResponse => {
  return partialResponse instanceof authority_pb.ChangesResponse
    ? partialResponse
    : new authority_pb.ChangesResponse(
      partialResponse
    );
};



export namespace PageAuthority {
  export type InitializeRequest =
    authority_pb.InitializeRequest;

  export type PartialInitializeRequest =
  protobuf_es.PartialMessage<authority_pb.InitializeRequest>;

  export type InitializeResponse =
    authority_pb.InitializeResponse;

  export type PartialInitializeResponse =
  protobuf_es.PartialMessage<authority_pb.InitializeResponse>;
}
export namespace PageAuthority {
  export type PageRequest =
    authority_pb.PageRequest;

  export type PartialPageRequest =
  protobuf_es.PartialMessage<authority_pb.PageRequest>;

  export type PageResponse =
    authority_pb.PageResponse;

  export type PartialPageResponse =
  protobuf_es.PartialMessage<authority_pb.PageResponse>;
}
export namespace PageAuthority {
  export type ApplyRequest =
    authority_pb.ApplyRequest;

  export type PartialApplyRequest =
  protobuf_es.PartialMessage<authority_pb.ApplyRequest>;

  export type ApplyResponse =
    authority_pb.ApplyResponse;

  export type PartialApplyResponse =
  protobuf_es.PartialMessage<authority_pb.ApplyResponse>;
}
export namespace PageAuthority {
  export type ChangesRequest =
    authority_pb.ChangesRequest;

  export type PartialChangesRequest =
  protobuf_es.PartialMessage<authority_pb.ChangesRequest>;

  export type ChangesResponse =
    authority_pb.ChangesResponse;

  export type PartialChangesResponse =
  protobuf_es.PartialMessage<authority_pb.ChangesResponse>;
}



const PAGE_AUTHORITY_INITIALIZE_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type PageAuthorityInitializeAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof PAGE_AUTHORITY_INITIALIZE_ERROR_TYPES
  >[number];

export class PageAuthorityInitializeAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      PAGE_AUTHORITY_INITIALIZE_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new PageAuthorityInitializeAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new PageAuthorityInitializeAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: PageAuthorityInitializeAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: PageAuthorityInitializeAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}



const PAGE_AUTHORITY_PAGE_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type PageAuthorityPageAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof PAGE_AUTHORITY_PAGE_ERROR_TYPES
  >[number];

export class PageAuthorityPageAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      PAGE_AUTHORITY_PAGE_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new PageAuthorityPageAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new PageAuthorityPageAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: PageAuthorityPageAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: PageAuthorityPageAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}



const PAGE_AUTHORITY_APPLY_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type PageAuthorityApplyAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof PAGE_AUTHORITY_APPLY_ERROR_TYPES
  >[number];

export class PageAuthorityApplyAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      PAGE_AUTHORITY_APPLY_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new PageAuthorityApplyAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new PageAuthorityApplyAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: PageAuthorityApplyAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: PageAuthorityApplyAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}



const PAGE_AUTHORITY_CHANGES_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type PageAuthorityChangesAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof PAGE_AUTHORITY_CHANGES_ERROR_TYPES
  >[number];

export class PageAuthorityChangesAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      PAGE_AUTHORITY_CHANGES_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new PageAuthorityChangesAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new PageAuthorityChangesAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: PageAuthorityChangesAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: PageAuthorityChangesAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}


class _Reactively {
  #id: string;
  #state: string;

  constructor(id: string, options?: reboot_api.CallOptions) {
    this.#id = id;
    this.#state = "dev.moment.page.v1alpha1.PageAuthority";
  }

  async page(
    context: reboot_web.WebContext,
    partialRequest?: PageAuthority.PartialPageRequest,
    options?: { signal?: AbortSignal },
  ): Promise<[
      AsyncGenerator<PageAuthority.PageResponse, void, unknown>,
      (newRequest: PageAuthority.PartialPageRequest) => void
    ]> {
    const request = PageAuthorityPageRequestToProtobuf(partialRequest);

    const [generator, setRequest] = reboot_web.reactively(
      {
        url: context.url,
        state: this.#state,
        method: "Page",
        id: this.#id,
        requestType: authority_pb.PageRequest,
        responseType: authority_pb.PageResponse,
        request: request,
        signal: options?.signal,
        bearerToken: context.bearerToken,
      }
    );

    const setTypedRequest = (newRequest: PageAuthority.PartialPageRequest): void => {
      const typedRequest = PageAuthorityPageRequestToProtobuf(newRequest);
      setRequest(typedRequest);
    };

    async function* typedGenerator(): AsyncGenerator<PageAuthority.PageResponse, void, unknown> {
     for await (const response of generator) {
      const typedResponse = PageAuthorityPageResponseFromProtobufShape(response);
      yield typedResponse;
      }
    };

    return [typedGenerator(), setTypedRequest];
  }

  async changes(
    context: reboot_web.WebContext,
    partialRequest?: PageAuthority.PartialChangesRequest,
    options?: { signal?: AbortSignal },
  ): Promise<[
      AsyncGenerator<PageAuthority.ChangesResponse, void, unknown>,
      (newRequest: PageAuthority.PartialChangesRequest) => void
    ]> {
    const request = PageAuthorityChangesRequestToProtobuf(partialRequest);

    const [generator, setRequest] = reboot_web.reactively(
      {
        url: context.url,
        state: this.#state,
        method: "Changes",
        id: this.#id,
        requestType: authority_pb.ChangesRequest,
        responseType: authority_pb.ChangesResponse,
        request: request,
        signal: options?.signal,
        bearerToken: context.bearerToken,
      }
    );

    const setTypedRequest = (newRequest: PageAuthority.PartialChangesRequest): void => {
      const typedRequest = PageAuthorityChangesRequestToProtobuf(newRequest);
      setRequest(typedRequest);
    };

    async function* typedGenerator(): AsyncGenerator<PageAuthority.ChangesResponse, void, unknown> {
     for await (const response of generator) {
      const typedResponse = PageAuthorityChangesResponseFromProtobufShape(response);
      yield typedResponse;
      }
    };

    return [typedGenerator(), setTypedRequest];
  }

}

class _Idempotently {
  #stateRef: string;
  #idempotencyKey: string;

  constructor(id: string, idempotencyKey: string, options?: reboot_api.CallOptions) {
    this.#stateRef = reboot_api.stateIdToRef("dev.moment.page.v1alpha1.PageAuthority", id);
    this.#idempotencyKey = idempotencyKey;
  }

  async initialize(
    context: reboot_web.WebContext,
    partialRequest?: PageAuthority.PartialInitializeRequest,
    options?: { signal?: AbortSignal },
  ): Promise<PageAuthority.InitializeResponse> {
    const request = PageAuthorityInitializeRequestToProtobuf(partialRequest);

    const responseProtobuf = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.page.v1alpha1.PageAuthorityMethods/Initialize",
        stateRef: this.#stateRef,
        requestType: authority_pb.InitializeRequest,
        responseType: authority_pb.InitializeResponse,
        abortedType: PageAuthorityInitializeAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: this.#idempotencyKey,
      });

    return PageAuthorityInitializeResponseFromProtobufShape(responseProtobuf);
  }

  async apply(
    context: reboot_web.WebContext,
    partialRequest?: PageAuthority.PartialApplyRequest,
    options?: { signal?: AbortSignal },
  ): Promise<PageAuthority.ApplyResponse> {
    const request = PageAuthorityApplyRequestToProtobuf(partialRequest);

    const responseProtobuf = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.page.v1alpha1.PageAuthorityMethods/Apply",
        stateRef: this.#stateRef,
        requestType: authority_pb.ApplyRequest,
        responseType: authority_pb.ApplyResponse,
        abortedType: PageAuthorityApplyAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: this.#idempotencyKey,
      });

    return PageAuthorityApplyResponseFromProtobufShape(responseProtobuf);
  }

}

export class PageAuthorityWeakReference {
  #id: string;
  #options?: reboot_api.CallOptions;

  constructor(id: string) {
    this.#id = id;
  }

  get stateId(): string {
    return this.#id;
  }

  public reactively() {
    return new _Reactively(
      this.#id,
    );
  }

  public idempotently({ key }: { key: string }) {
    return new _Idempotently(
      this.#id,
      key,
    );
  }


  async initialize(
    context: reboot_web.WebContext,
    partialRequest?: PageAuthority.PartialInitializeRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<PageAuthority.InitializeResponse> {

    const request = PageAuthorityInitializeRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.page.v1alpha1.PageAuthority",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.page.v1alpha1.PageAuthorityMethods/Initialize",
        stateRef: stateRef,
        requestType: authority_pb.InitializeRequest,
        responseType: authority_pb.InitializeResponse,
        abortedType: PageAuthorityInitializeAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return PageAuthorityInitializeResponseFromProtobufShape(protobufResponse);
  }


  async page(
    context: reboot_web.WebContext,
    partialRequest?: PageAuthority.PartialPageRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<PageAuthority.PageResponse> {

    const request = PageAuthorityPageRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.page.v1alpha1.PageAuthority",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.page.v1alpha1.PageAuthorityMethods/Page",
        stateRef: stateRef,
        requestType: authority_pb.PageRequest,
        responseType: authority_pb.PageResponse,
        abortedType: PageAuthorityPageAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return PageAuthorityPageResponseFromProtobufShape(protobufResponse);
  }


  async apply(
    context: reboot_web.WebContext,
    partialRequest?: PageAuthority.PartialApplyRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<PageAuthority.ApplyResponse> {

    const request = PageAuthorityApplyRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.page.v1alpha1.PageAuthority",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.page.v1alpha1.PageAuthorityMethods/Apply",
        stateRef: stateRef,
        requestType: authority_pb.ApplyRequest,
        responseType: authority_pb.ApplyResponse,
        abortedType: PageAuthorityApplyAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return PageAuthorityApplyResponseFromProtobufShape(protobufResponse);
  }


  async changes(
    context: reboot_web.WebContext,
    partialRequest?: PageAuthority.PartialChangesRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<PageAuthority.ChangesResponse> {

    const request = PageAuthorityChangesRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.page.v1alpha1.PageAuthority",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.page.v1alpha1.PageAuthorityMethods/Changes",
        stateRef: stateRef,
        requestType: authority_pb.ChangesRequest,
        responseType: authority_pb.ChangesResponse,
        abortedType: PageAuthorityChangesAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return PageAuthorityChangesResponseFromProtobufShape(protobufResponse);
  }

}

export class PageAuthority {

  static WeakReference = PageAuthorityWeakReference;

  public static ref(
    id: string,
    options?: { bearerToken?: string }
  ) {
    return new PageAuthority.WeakReference(id, options?.bearerToken);
  }



}

export namespace PageAuthority {
  export type WeakReference = typeof PageAuthority.WeakReference.prototype;
}

